import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

// Base styles
const getBackgroundColor = (theme, color) => {
  const map = {
    warning: theme.palette.warning.main,
    success: theme.palette.success.main,
    danger: theme.palette.error.main,
    info: theme.palette.info.main,
    primary: theme.palette.primary.main,
    rose: "#e91e63",
  };
  return map[color] || "transparent";
};

// Styled root component
const CardHeaderRoot = styled(Box, {
  shouldForwardProp: (prop) =>
    !["color", "plain", "stats", "icon"].includes(prop),
})(({ theme, color, plain, stats, icon }) => ({
  padding: "0.75rem 1.25rem",
  marginBottom: "0",
  borderBottom: "none",
  background: color ? getBackgroundColor(theme, color) : "transparent",
  color: "#fff",
  ...(plain && {
    marginLeft: "0px",
    marginRight: "0px",
  }),
  ...(stats && {
    background: "#f5f5f5",
    color: "#555",
  }),
  ...(icon && {
    background: "#fff",
    textAlign: "center",
    padding: "20px",
  }),
}));

export default function CardHeader(props) {
  const { children, color, plain, stats, icon, ...rest } = props;

  return (
    <CardHeaderRoot
      color={color}
      plain={plain ? 1 : 0}
      stats={stats ? 1 : 0}
      icon={icon ? 1 : 0}
      {...rest}
    >
      {children}
    </CardHeaderRoot>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(["warning", "success", "danger", "info", "primary", "rose"]),
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  children: PropTypes.node,
};
